module.exports = __webpack_public_path__ + "img/t05.f52e8c4f.jpg";